export const T_PREFIX = 'products-fe.containers.partner';
